import { Link } from "@tanstack/react-router";

/**
 * Vaste conversieblok onderaan publieke contentpagina's: één duidelijke
 * uitnodiging om een taxi te boeken met een vaste prijs.
 */
export function BookCta({
  locale = "nl",
  heading,
  text,
  label,
}: {
  locale?: "nl" | "en";
  heading?: string;
  text?: string;
  label?: string;
}) {
  const en = locale === "en";
  return (
    <div className="mt-10 rounded-2xl border border-border bg-card p-6 text-center shadow-sm">
      <h2 className="font-display text-lg font-bold">
        {heading ?? (en ? "Book a taxi at a fixed price" : "Taxi boeken met een vaste prijs")}
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        {text ??
          (en
            ? "Enter your pick-up address and destination to see the fixed price for your ride."
            : "Vul uw ophaaladres en bestemming in en u ziet direct de vaste prijs voor uw rit.")}
      </p>
      <Link
        to={en ? "/en/book" : "/boeken"}
        className="mt-4 inline-flex items-center justify-center rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
      >
        {label ?? (en ? "Book a taxi" : "Taxi boeken")}
      </Link>
    </div>
  );
}
